import { render, staticRenderFns } from "./StartTranstions.vue?vue&type=template&id=031c9842&scoped=true"
import script from "./StartTranstions.vue?vue&type=script&lang=js"
export * from "./StartTranstions.vue?vue&type=script&lang=js"
import style0 from "./StartTranstions.vue?vue&type=style&index=0&id=031c9842&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c9842",
  null
  
)

export default component.exports